module.exports = __webpack_public_path__ + "img/error-icon.df7af686.svg";